import "./HomeFaq.scss";
import Btn from "../../../components/btn/Btn";
import { motion } from "framer-motion";
import Accordion from "react-bootstrap/Accordion";
import { IoIosArrowUp } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { paths } from "../../../utils/paths";
import { useContext } from "react";
import { mainContext } from "../../../utils/WebContext";

const HomeFaq = ({ pageData, dataList }) => {
  const navigate = useNavigate();
  const { involvedService } = useContext(mainContext);

  return (
    <section className="get_involved p_t p_b">
      <div className="content_wrap p_b">
        <motion.p
          initial={{ translateX: 32, opacity: 0 }}
          whileInView={{ translateX: 0, opacity: 1 }}
          transition={{
            duration: 0.6,
            ease: "easeInOut",
          }}
                 viewport={{ once: true }}
          className="tag_title mt-5 pt-5"
        >
          <span>_</span>Get Involved
        </motion.p>
        <div className="title_btn">
          <motion.h2
            initial={{ translateY: 32, opacity: 0 }}
            whileInView={{ translateY: 0, opacity: 1 }}
            transition={{
              duration: 0.6,
              ease: "easeInOut",
            }}
                   viewport={{ once: true }}
          >
            Get Involved and Create Change
          </motion.h2>
          <Btn
            theme="dark"
            title="Know more"
            onClick={() =>
              navigate(`/get-involved/${involvedService?.[0]?.slug}`)
            }
          />
        </div>

        <div className="tab_wraper mt-5\">
          <Accordion defaultActiveKey="0">
            {dataList?.map((data, l) => {
              return (
                <Accordion.Item eventKey={`${l}`} key={data?._id}>
                  <Accordion.Header>
                    <h3>{data?.name}</h3> <IoIosArrowUp />
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>{data?.description}</p>
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </div>
      </div>
      {/* <div className="content_wrap mutual_sec">
        <motion.div
          initial={{ translateY: 32, opacity: 0 }}
          whileInView={{ translateY: 0, opacity: 1 }}
          transition={{
            duration: 0.8,
            ease: "easeInOut",
          }}
          className="sec_content"
        >
          <p className="tag_title">
            <span>_</span>
            {pageData?.cta_title}{" "}
          </p>
          <div className="title_line">
            <h2>{pageData?.cta_heading}</h2>
            <Btn
              theme="dark"
              title={pageData?.cta_button_name}
              onClick={() => navigate(`${paths.ABOUT}`)}
            />
          </div>
        </motion.div>
      </div> */}
    </section>
  );
};
export default HomeFaq;
